import React from "react";
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, Container } from "reactstrap";
import { Link } from "react-router-dom";

import SignOutButton from "./SignOut";
import * as routes from "../constants/routes";

import AuthUserContext from "./AuthUserContext";

const Navigation = () => (
  <AuthUserContext.Consumer>
    {authUser =>
      authUser ? <NavigationAuth userInfo={authUser} /> : <NavigationNonAuth />
    }
  </AuthUserContext.Consumer>
);

const NavigationNonAuth = () => (
  <Navbar light expand="md">
    <NavbarBrand>
      <Link  style={{ textDecoration: 'none'}}  to={routes.LANDING}> DELIVEYTALLA </Link>
    </NavbarBrand>
    <Nav className="ml-auto" navbar >
      <NavItem>
        <NavLink>
          <Link style={{ textDecoration: 'none' }}  to={routes.SIGN_IN}>Sign In</Link>
        </NavLink>
      </NavItem>
    </Nav>
  </Navbar>
);

export default Navigation;

const NavigationAuth = ({ userInfo }) => (
  <Navbar expand="md" >
    <NavbarBrand >
      <Link style={{ textDecoration: 'none', fontSize: '16px', }}  to={routes.LANDING}> DELIVEYTALLA </Link>
    </NavbarBrand>
    <hr />
    <Nav color="faded" className="justify-content-center" variant="tabs">
      <NavItem>
        <NavLink>
          <Link style={{ textDecoration: 'none',fontSize: '14px' }}  to={routes.HOME}>HOME | </Link>
          <Link style={{ textDecoration: 'none',fontSize: '14px' }}  to={routes.SHOPLIST}>ORDER | </Link>
          <Link style={{ textDecoration: 'none',fontSize: '14px' }}  to={routes.MY_ORDERS}>MY ORDERS | </Link>
          {/* <Link to={routes.ITEM_ENTRY}>ADD ITEM</Link> */}
          <Link style={{ textDecoration: 'none',fontSize: '14px' }}  to={routes.ACCOUNT}>ACCOUNT</Link>
        </NavLink>
      </NavItem>

      {/* //the below is disabled as we are not using facebook authentication */}
      {/* {userInfo.providerData[0].providerId === "facebook.com" ? null : (
        <NavItem>
          <NavLink>
            <Link to={routes.ACCOUNT}>Account</Link>
          </NavLink>
        </NavItem>
      )} */}

      {/* removing signout button from navigation bar */}
      {/* <NavItem>
        <SignOutButton />
      </NavItem> */}
    </Nav>
    <hr />
  </Navbar>
);

// const NavigationAuth = ({ userInfo }) => (
//   <ul>
//     {/* {console.log("NavigationAuth", userInfo)} */}
//     <li>
//       <Link to={routes.LANDING}>Landing</Link>
//     </li>
//     <li>
//       <Link to={routes.HOME}>Home</Link>
//     </li>
//     {/* disabling password changes/resets if user is logged in through facebook */}
//     {userInfo.providerData[0].providerId === "facebook.com" ? null : (
//       <li>
//         <Link to={routes.ACCOUNT}>Account</Link>
//       </li>
//     )}
//     <li>
//       <SignOutButton />
//     </li>
//   </ul>
// );

// const NavigationNonAuth = () => (
//   <ul>
//     <li>
//       <Link to={routes.LANDING}>Landing</Link>
//     </li>
//     <li>
//       <Link to={routes.SIGN_IN}>Sign In</Link>
//     </li>
//   </ul>
// );
